export default {"src":"/nachrichten/_next/static/media/spinner-dark.f12d765a.svg","height":83,"width":83,"blurWidth":0,"blurHeight":0};